
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 64 64","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.379 12.552a2 2 0 1 0-2.758 2.897L49.963 30H10a2 2 0 0 0 0 4h39.899L34.621 48.552a2 2 0 1 0 2.758 2.896l17.449-16.62C55.584 34.073 56 33.069 56 32s-.416-2.073-1.207-2.862z"}})])
          )
        }
      }
    